import React, { useState, useEffect } from 'react';
import { ChevronRight, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: 'Specialists in MV/LV Switchgears',
      subtitle: 'Motor Control Centers, Power Distribution Boards and Turnkey Solutions',
      image: '/images/hero/hero-slide-1.jpg',
    },
    {
      title: 'Renewable Energy',
      subtitle: 'Powering Africa with reliable and sustainable power',
      image: '/images/hero/hero-slide-2.jpg',
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section className="relative pt-20 min-h-[90vh] flex items-center overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{ 
              backgroundImage: `url(${slide.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/30"></div>
        </div>
      ))}

      <div className="container mx-auto px-4 md:px-6 relative z-10 py-16">
        <div className="max-w-3xl">
          <div className="inline-flex items-center bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium mb-6">
            <MapPin size={16} className="mr-2" />
            Nairobi, Kenya
          </div>
          
          <div className="relative h-[160px] md:h-[180px]">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`absolute inset-0 transition-all duration-700 ${
                  index === currentSlide 
                    ? 'opacity-100 translate-y-0' 
                    : 'opacity-0 translate-y-8'
                }`}
              >
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
                  {slide.title}
                </h1>
                <p className="text-lg md:text-xl text-white/90 max-w-xl">
                  {slide.subtitle}
                </p>
              </div>
            ))}
          </div>
          
          <div className="flex flex-wrap gap-4 mt-8">
            <Link
              to="/solutions"
              className="bg-[#006D77] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#00555C] transition-all shadow-lg flex items-center gap-2 text-base"
            >
              Explore Solutions
              <ChevronRight size={18} />
            </Link>
            <Link
              to="/projects"
              className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white/10 transition-all text-base"
            >
              View Projects
            </Link>
          </div>

          <div className="flex gap-3 mt-8">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`rounded-full transition-all duration-300 ${
                  index === currentSlide 
                    ? 'w-3 h-3 bg-white' 
                    : 'w-3 h-3 bg-white/40 hover:bg-white/60'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>

          <div className="flex flex-wrap gap-8 mt-10">
            <div>
              <div className="text-2xl font-bold text-white">25+</div>
              <div className="text-sm text-white/70">Panels Built</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-white">12+</div>
              <div className="text-sm text-white/70">VFD Installations</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-white">30+</div>
              <div className="text-sm text-white/70">Sites Completed</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
